import { EstateId, EstateLegalId, ExposedEstate } from '../../../domain';

export const mapExposedEstateDtoToDomain = ({
  estateId,
  legalId,
}: {
  estateId: number;
  legalId: string;
}): ExposedEstate => {
  return {
    estateId: new EstateId(estateId),
    legalId: new EstateLegalId(Number(legalId)),
  };
};
